module.exports = __webpack_public_path__ + "img/Certificate_Mobile@1x.cc58f2e.webp";